import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {FETCH_ALL_SETTINGS, UPDATE_SETTING, FETCH_MORTGAGE_RATES} from '../actionTypes'
import {API_CALL_STATUS} from '../../metadata/enums'
import Config from "../../config";
import axios from "axios";
import {LOGGER} from "../../utils/Logger";

const initialState = {
	settings: [],
	status: API_CALL_STATUS.IDLE,
	error: null,
	updated_settings: false,
	mortgage_rates_30: null,
	mortgage_rates_15: null
}


export const getMortgageRates = createAsyncThunk(FETCH_MORTGAGE_RATES, async (payload) => {
	const config = {
		method: 'get',
		url: `${Config.BACKEND_URL}mortgage-rates?years=${payload.years}`,
		headers: {Authorization: payload.token},
	}
	let res = await axios(config)
	return { mortgage_rates: res.data, years: payload.years }
})

export const getSettingsData = createAsyncThunk(FETCH_ALL_SETTINGS, async (payload) => {
	const config = {
		method: 'get',
		url: `${Config.BACKEND_URL}settings`,
		headers: {Authorization: payload.token},
	}
	let res = await axios(config)
	return res.data
})

export const updateSettingsData = createAsyncThunk(UPDATE_SETTING, async (payload) => {
	const config = {
		method: 'put',
		url: `${Config.BACKEND_URL}settings/${payload.data._id}`,
		headers: {Authorization: payload.token},
		data: payload.data
	}
	let res = await axios(config)
	console.log('updated settings')
	return payload.data
})


const settingsSlice = createSlice({
	name: 'analytics',
	initialState,
	reducers: {
		updateSettingsUpdatedStatus(state, action) {
			return Object.assign({}, state, {updated_settings: action.payload})
		},
	},
	extraReducers(builder) {
		builder
		.addCase(getMortgageRates.pending, (state, action) => {
			state.status = API_CALL_STATUS.LOADING
		})
		.addCase(getMortgageRates.fulfilled, (state, action) => {
			state.status = API_CALL_STATUS.SUCCEEDED
			let {mortgage_rates, years} = action.payload
			if(years === 15)
				state.mortgage_rates_15 = mortgage_rates
			else
				state.mortgage_rates_30 = mortgage_rates
		})
		.addCase(getMortgageRates.rejected, (state, action) => {
			state.status = API_CALL_STATUS.FAILED
			state.error = action.error.message
		})
		.addCase(getSettingsData.pending, (state, action) => {
			state.status = API_CALL_STATUS.LOADING
		})
		.addCase(getSettingsData.fulfilled, (state, action) => {
			state.status = API_CALL_STATUS.SUCCEEDED
			state.settings = action.payload
		})
		.addCase(getSettingsData.rejected, (state, action) => {
			state.status = API_CALL_STATUS.FAILED
			state.error = action.error.message
		})
		.addCase(updateSettingsData.pending, (state, action) => {
			state.status = API_CALL_STATUS.LOADING
		})
		.addCase(updateSettingsData.fulfilled, (state, action) => {
			state.status = API_CALL_STATUS.SUCCEEDED
			let temp = []
			let updatedSettings = action.payload
			state.settings.forEach(setting => {
				if (setting._id !== updatedSettings._id)
					temp.push(setting)
			})
			temp.push(updatedSettings)
			state.settings = temp
			state.updated_settings = true
		})
		.addCase(updateSettingsData.rejected, (state, action) => {
			state.status = API_CALL_STATUS.FAILED
			state.error = action.error.message
		})
	}
})


export const getAssumptionsSettings = (state) => {
	let salesSettings = {_id: 'assumptions'}
	state.settings.forEach(setting => {
		if (setting._id === 'assumptions')
			salesSettings = setting
	})
	return salesSettings
}



export const {updateSettingsUpdatedStatus} = settingsSlice.actions
export default settingsSlice.reducer
